import { virtualDir } from "#skyward_global";
import { newModalLayer } from "#skyward_modalLayer";
import { getClientHeight, getClientWidth, getNextPopupId, notifyDOMLoad, popupList } from "#skyward_window";
import { encodeHtml } from "./skyward.base.extensions";
import { registerEvents } from "./skyward.ui.events";
import { getNode, getOuterHtml } from "./skyward.ui.htmlGatherer";
import { HtmlGathererSettings, JQueryInput } from "./types";

const events =
{
    customPrintScreen,
    capture
};

registerEvents("printScreen", events);

export function launchWorkflow(url: string, data: any)
{
    return $.ajax(
        {
            url: url,
            type: "POST",
            dataType: "viewparthtml",
            data: data,
            success: function (html)
            {
                const popupId = "popup" + getNextPopupId();
                const popupContent = $("<div/>", { class: "popup workflowPopup", id: popupId, html: html });

                newModalLayer(popupContent, null!, { closeOnClick: false, closeOnEscape: false, closeOnRecordSelected: false });
                popupList.push(popupContent);
                notifyDOMLoad("#" + popupId);
            }
        });
}

async function customPrintScreen(this: JQueryInput)
{
    const button = $(this);
    const buttonData = button.data();
    const postData = buttonData;

    if (buttonData.includePageHtml == true)
    {
        const doc = $(window.document);
        const html = await captureHtml(doc);
        postData.html = encodeHtml(getOuterHtml(html)!);
    }

    launchWorkflow(`${virtualDir}${buttonData.module}/${buttonData.controller}/${buttonData.action}`, postData);
}

async function capture()
{
    const doc = $(window.document);
    const scrollableData = getScrollableData(doc);

    const clientWidth = getClientWidth();
    const clientHeight = getClientHeight();

    const data =
    {
        html: encodeHtml(getOuterHtml(await captureHtml(doc))!),
        windowWidth: clientWidth > 0 ? clientWidth : $(window).width(),
        windowHeight: clientHeight > 0 ? clientHeight : $(window).height(),
        ScrollableElements: scrollableData
    };

    launchWorkflow(virtualDir + "Common/PrintScreen/PrintScreen", { data: JSON.stringify(data) });
}

async function captureHtml(doc: JQuery<Document>)
{
    const options: HtmlGathererSettings =
    {
        stripJavaScript: true,
        isMassPrintOnlineForm: false
    };

    const originalHtmlNode = doc.find("html");
    const htmlNode = await getNode(originalHtmlNode, options);
    applyPrintScreenToolbarFixes(originalHtmlNode, htmlNode);

    return htmlNode;
}

// Apply `gap: 0` to empty toolbar parts. In the PDF render, this can cause the toolbar to infinitely expand making the page look blank.
 // This style must be applied inline. The PDF render ignores this if it's set with CSS.
function applyPrintScreenToolbarFixes(originalHtml: JQuery<HTMLElement>, clonedHtml: JQuery<HTMLElement>)
{
    const toolbarPartSelector = ".toolbar--flexed .toolbarLeft, .toolbar--flexed .toolbarRight";
    const originalToolbarParts = originalHtml.find(toolbarPartSelector);
    const clonedToolbarParts = clonedHtml.find(toolbarPartSelector);

    originalToolbarParts.each(function (index)
    {
        const originalPart = $(this);

        const clonedPart = clonedToolbarParts.eq(index);
        if (!clonedPart.length)
        {
            return;
        }

        if (!hasVisibleElements(originalPart))
        {
            clonedPart.css("gap", "0");
            return;
        }

        const moreMenuArea = originalPart.find(".moreMenuArea");
        if (!hasVisibleElements(moreMenuArea))
        {
            clonedPart.find(".moreMenuArea").css("gap", "0");
        }
    });
}

function hasVisibleElements(elements: JQuery<HTMLElement>)
{
    return elements.children().filter(":visible").length > 0;
}

function getScrollableData(document: JQuery<Document>)
{
    return getElementScrollableInformation(document);

    function getUniqueSelector(targetElem: HTMLElement)
    {
        const selector: string[] = [];
        for (let elem = targetElem; elem.parentElement !== null; elem = elem.parentElement)
        {
            const id = elem.getAttribute("id");
            if (id !== null)
            {
                selector.unshift("#" + id);
                return selector.join(">");
            }
            selector.unshift(`:nth-child(${getPosition(elem)! + 1})`);
        }

        selector.unshift(":root");
        return selector.join(">");

        function getPosition(elem: HTMLElement)
        {
            const parent = elem.parentElement;
            for (let i = 0; i < parent!.childElementCount; i++)
            {
                if (parent!.children[i] === elem)
                {
                    return i;
                }
            }
            return -1;
        }
    }

    function getElementScrollableInformation(doc: JQuery<Document>)
    {
        const scrollables: Array<any> = [];
        function addScrollable(element: JQueryInput, selector: string)
        {
            const scrollable = $(element);
            const scrollTop = scrollable.scrollTop();
            const scrollLeft = scrollable.scrollLeft();

            if (scrollTop === 0 && scrollLeft === 0)
            {
                return;
            }

            scrollables.push({ Selector: selector, Top: Math.trunc(scrollTop!), Left: Math.trunc(scrollLeft!) });
        };
        // Using '*' to grab all elements, as searching by :scrollable excludes overflow: hidden elements.
        doc.find('*').each(function (this: HTMLElement) { addScrollable(this, getUniqueSelector(this)); });
        // The browser might use html or body for document scrolling; the PDF renderer uses body
        // and doesn't support document.scrollingElement
        addScrollable(doc as unknown as JQuery<HTMLElement>, "body");

        return scrollables;
    }
}